module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-7",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Table of Contents")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")]), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#accomplice"
    }
  }, [_vm._v("Accomplice")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#aethelwyne"
    }
  }, [_vm._v("Aethelwyne")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#alesund"
    }
  }, [_vm._v("Ålesund")])]), _c('span', {
    staticClass: "Introduction-Project-Title char-style-override-10"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#alternatingCurrent"
    }
  }, [_vm._v("Alternating Current")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#blackthorn"
    }
  }, [_vm._v("Blackthorn")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#boxPleats"
    }
  }, [_vm._v("Box Pleats")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#brunnhilde"
    }
  }, [_vm._v("Brünnhilde")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#ceangaltas"
    }
  }, [_vm._v("Ceangaltas")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#chevalier"
    }
  }, [_vm._v("Chevalier")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#driver"
    }
  }, [_vm._v("Driver")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#eveningLight"
    }
  }, [_vm._v("Evening Light")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("Filigree")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#glaistig"
    }
  }, [_vm._v("Glaistig")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#goldenBracelets"
    }
  }, [_vm._v("Golden Bracelets")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#gothic"
    }
  }, [_vm._v("Gothic")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#gretel"
    }
  }, [_vm._v("Gretel")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#houndstoothMiscellany"
    }
  }, [_vm._v("Houndstooth Miscellany")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#jackInTheBox"
    }
  }, [_vm._v("Jack-in-the-Box")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#negativeSpace"
    }
  }, [_vm._v("Negative Space")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#plush"
    }
  }, [_vm._v("Plush")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#poppy"
    }
  }, [_vm._v("Poppy")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#rusalka"
    }
  }, [_vm._v("Rusalka")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#sheltie"
    }
  }, [_vm._v("Sheltie")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#snug"
    }
  }, [_vm._v("Snug")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#standardDeviation"
    }
  }, [_vm._v("Standard Deviation")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#strata"
    }
  }, [_vm._v("Strata")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#tapisserie"
    }
  }, [_vm._v("Tapisserie")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-11"
  }, [_c('a', {
    attrs: {
      "href": "#/section#welig"
    }
  }, [_vm._v("Welig")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('a', {
    attrs: {
      "href": "#/section#selectingMaterials"
    }
  }, [_vm._v("Selecting Materials")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("Special Techniques")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('a', {
    attrs: {
      "href": "#/section#abbreviations"
    }
  }, [_vm._v(" Abbreviations")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('span', {
    attrs: {
      "href": "#/endMatter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Projects by Yarn Weight")]), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('span', {
    attrs: {
      "href": "#/endMatter#sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources for Supplies")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('span', {
    attrs: {
      "href": "#/endMatter#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-9"
  }, [_c('span', {
    attrs: {
      "href": "#/endMatter#acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0